var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 44 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4E4E4E",
  d: "M.11 7.423a6.8 6.8 0 0 0 1.468 5.58 6.69 6.69 0 0 0 5.186 2.301h9.988l.547-2.977H6.764a3.72 3.72 0 0 1-2.91-1.266 3.9 3.9 0 0 1-.806-3.179C3.48 5.236 6.073 2.98 8.723 2.98h10.248L19.518 0H8.725C4.562-.001.773 3.268.11 7.423M42.908 7.883c-.663 4.157-4.452 7.421-8.617 7.421h-7.393l2.975 2.97 2.977 2.973h-4.222l-2.972-2.972-2.975-2.974.546-2.975H34.29c2.652 0 5.244-2.256 5.677-4.904a3.89 3.89 0 0 0-.807-3.178 3.72 3.72 0 0 0-2.91-1.267H24.898l.546-2.976h10.805a6.7 6.7 0 0 1 5.186 2.3 6.8 6.8 0 0 1 1.473 5.582"
})));
export default SvgCr;